import { getId } from '@src/containers/UtmGenerator/helpers'

export const PrefixUrlData = [
  {
    id: getId(),
    name: 'protocol',
    value: 'https',
    label: 'https://'
  },
  {
    id: getId(),
    name: 'protocol',
    value: 'http',
    label: 'http://'
  }
]
